import { render, staticRenderFns } from "./BusinessInfoForm.vue?vue&type=template&id=531f43e0&scoped=true&"
import script from "./BusinessInfoForm.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfoForm.vue?vue&type=style&index=0&id=531f43e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f43e0",
  null
  
)

export default component.exports